import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiState } from '../../../types/api';
import { RootState } from '../..';
import { IMfaApiResponse, IMfaSettings } from './mfaTypes';

const initialState: IApiState<IMfaApiResponse<IMfaSettings>> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getUserSettingsAsync = createAsyncThunk(
  'settings/get',
  async (_: void, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const { data } = await api.get<IMfaApiResponse<IMfaSettings>>(
        '/settings',
        {
          headers: {
            Authorization: `Token ${accessToken}`,
            'X-Business-Id': businessId,
          },
        },
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IMfaApiResponse<IMfaSettings>>;
      return rejectWithValue(error.response?.data);
    }
  },
);

export const getUserSettingsSlice = createSlice({
  name: 'settings/get',
  initialState,
  reducers: {
    resetUserSettings: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserSettingsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getUserSettingsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload;
      })
      .addCase(getUserSettingsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IMfaApiResponse<IMfaSettings>;
        state.error = action.error.message;
      });
  },
});

export const { resetUserSettings } = getUserSettingsSlice.actions;

export default getUserSettingsSlice.reducer;
